module.exports = __webpack_public_path__ + "static/img/短视频-口播种草短视频.7575f35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10005/短视频-口播种草短视频.png
// module id = fkgj
// module chunks = 1